import {PublicTicketsForm} from "./PublicTicketsForm";

function initPublicTicketsIndex() {
    new PublicTicketsForm({
        formElement: document.querySelector('.tickets-form-container'),
    });

    // Methods
}

export {initPublicTicketsIndex}
